import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import HomePage from "@/pages/HomePage";
import SocialKitPage from "@/components/SocialKit";
import AffiliatesArea from "@/pages/AffiliatesArea";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/social-kit" element={<SocialKitPage />} />
          <Route path="/area-affiliati" element={<AffiliatesArea />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
